





































import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'
import {
  defineComponent,
  vue3Model,
  ref,
  computed
} from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    CTextArea
  },
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  setup(props, { emit }) {
    const selectedReason = ref('')
    const notes = ref<string | null>(null)
    const availableReasons = [
      'Πουλήθηκε',
      'Ψευτικα στοιχεία',
      'Τηλ/link στην περιγραφή'
    ]

    const visible = computed({
      get() {
        return props.modelValue
      },
      set(value: boolean) {
        emit('update:modelValue', value)
      }
    })

    function onHidden() {
      selectedReason.value = ''
      notes.value = null
    }

    function onConfirm() {
      emit('ok', {
        reason: selectedReason.value,
        notes: notes.value
      })

      selectedReason.value = ''
      notes.value = null
    }

    return {
      availableReasons,
      selectedReason,
      notes,
      visible,
      onHidden,
      onConfirm
    }
  }
})
